<div class="accordion"
     id="accordionGroups"
>
    <div *ngFor="let item of accordionData.allHeaders"
         class="accordion-item"
    >
        <h2 class="accordion-header">
            <button [attr.aria-controls]="'a' + item.id"
                    [attr.data-bs-target]="'#a' + item.id"
                    [aria-expanded]="item?.opened||false"
                    [class]="'accordion-button ' + (item?.opened === true ? ' ' :'collapsed')"
                    data-bs-toggle="collapse"
                    type="button"
            >
                <span *ngIf="!item.editHeaderText">{{ item.headerText }}</span>
                <app-component-input-inline (emitSave)="saveHeaderName($event, item.id)"
                                            *ngIf="item.editHeaderText"
                                            [editByPen]="true"
                                            [value]="item.headerText"
                ></app-component-input-inline>
            </button>
        </h2>
        <div [attr.data-bs-parent]="'#a' + item.id"
             [id]="'a' + item.id"
             [class]="'accordion-collapse collapse ' + (item?.opened === true ? 'show' :'')"
        >
            <div class="accordion-body">
                <ng-container
                        *ngTemplateOutlet="accordionData.templateAccordionBody; context: {data: item.dataForTemplate}"
                ></ng-container>
            </div>
        </div>
    </div>
</div>
